import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';
import { KeywordSet } from '@rsos/reduxDataStore';

export { GPX_EVENT_TYPES } from '@rsos/gainsight';

export const KEYWORD_EVENTS = Object.freeze({
  NEW_KEYWORD_TOPIC: 'new_keyword_topic',
  EDITED_KEYWORD_TOPIC: 'edited_keyword_topic',
  DELETED_KEYWORD_TOPIC: 'deleted_keyword_topic',
  ADDED_MANUAL_KEYWORD: 'added_manual_keyword',
  ADDED_SUGGESTED_KEYWORD: 'added_suggested_keyword',
  REMOVED_KEYWORD: 'removed_keyword',
});

export const trackKeywordAdminEvent = ({
  event,
  type,
  data,
}: {
  event: string;
  type: (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
  data: Record<string, unknown>;
}) => {
  gspx.trackEvent({
    name: event,
    type: type,
    feature: GPX_FEATURES.KEYWORD_DETECTION,
    capability: GPX_CAPABILITIES.COMMUNICATOR_SUMMARIZATION_AND_KEYWORDS,
    route: GPX_ROUTES.ADMIN,
    entities: data,
  });
};

export const trackNewKeywordTopicEvent = (keywordSet: KeywordSet) => {
  trackKeywordAdminEvent({
    event: KEYWORD_EVENTS.NEW_KEYWORD_TOPIC,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keywordSet,
    },
  });
};

export const trackChangedKeywordTopicEvent = (keywordSet: KeywordSet) => {
  trackKeywordAdminEvent({
    event: KEYWORD_EVENTS.EDITED_KEYWORD_TOPIC,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keywordSet,
    },
  });
};

export const trackDeletedKeywordTopicEvent = (keywordSet: KeywordSet) => {
  trackKeywordAdminEvent({
    event: KEYWORD_EVENTS.DELETED_KEYWORD_TOPIC,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keywordSet,
    },
  });
};

export const trackManualKeywordEvent = (
  keywordSet: KeywordSet,
  keyword: string,
) => {
  trackKeywordAdminEvent({
    event: KEYWORD_EVENTS.ADDED_MANUAL_KEYWORD,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keyword,
      keyword_set: keywordSet,
    },
  });
};

export const trackSuggestedKeywordEvent = (
  keywordSet: KeywordSet,
  keyword: string,
  preexistingKewordCount: number,
) => {
  trackKeywordAdminEvent({
    event: KEYWORD_EVENTS.ADDED_SUGGESTED_KEYWORD,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keyword,
      preexisting_keyword_count: preexistingKewordCount,
      keyword_set: keywordSet,
    },
  });
};

export const trackRemovedKeywordEvent = (
  keywordSet: KeywordSet,
  keyword: string,
) => {
  trackKeywordAdminEvent({
    event: KEYWORD_EVENTS.REMOVED_KEYWORD,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      keyword,
      keyword_set: keywordSet,
    },
  });
};

export const trackChangeKeywordEvent = <T extends keyof KeywordSet>(
  keywordSet: KeywordSet,
  key: T,
  oldValue: KeywordSet[T],
  newValue: KeywordSet[T],
) => {
  trackKeywordAdminEvent({
    event: `changed_keyword_topic_${key}`,
    type: GPX_EVENT_TYPES.INFO,
    data: {
      keyword_set_id: keywordSet.id,
      old_value: oldValue,
      new_value: newValue,
      keyword_set: keywordSet,
    },
  });
};
